$("document").ready(function () {
  $(window).on("load", function () {
    $(".step-progress-bar-inner-sct").addClass("active-jtpl");
    $(".step-three.final").removeClass("active-jtpl");
  });

  $(".meals-title-jtpl, .meals-title-jtpl").hide();

  $(document).on("click", ".see-details-text", function () {
    $(this)
      .parents(".line-item__content-wrapper")
      .find(".popup-see-proucts")
      .show();
  });
  $(document).on("click", ".close-icon-popup", function () {
    $(this)
      .parents(".line-item__content-wrapper")
      .find(".popup-see-proucts")
      .hide();
  });

  $("body").on("click", ".addon-tab-btn", function () {
    var $this = $(this);
    var id = $(this).attr("id");
    $(".addon-tab-btn").removeClass("active");
    $this.addClass("active");
    $(".add-on-tab-content").removeClass("active-jtpl");
    $("." + id).addClass("active-jtpl");
  });

  $("body").on("click", ".main-tabs", function () {
    var $this = $(this);
    var id = $(this).attr("id");
    $(".main-tabs").removeClass("active");
    $this.addClass("active");
    $(".main-tab-content").removeClass("active-jtpl");
    $("." + id).addClass("active-jtpl");
    $(".challenge-title").removeClass("active-jtpl");
    $("." + id).addClass("active-jtpl");
    $(".footer-progress-bar-buttons").removeClass("active-jtpl");
    $(".footer-progress-bar-buttons." + id).addClass("active-jtpl");
  });

  $("body").on("click", ".tabs-button-jtpl", function (e) {
    e.preventDefault();
    var $this = $(this);
    var id = $(this).attr("id");
    if (id == "everyday-meals-jtpl") {
      $(".tabs-button-jtpl").removeClass("active");
      $this.addClass("active");
      $(".tabs-button-content").addClass("active-jtpl");
      $(".meals-title-jtpl, .meals-title-jtpl").hide();
    } else {
      $(".tabs-button-jtpl").removeClass("active");
      $this.addClass("active");
      $(".tabs-button-content").removeClass("active-jtpl");
      $("." + id).addClass("active-jtpl");
      $(".meals-title-jtpl, .meals-title-jtpl").show();
    }
  });

  // Arrays to store hot meals, sweet dishes, every meals, and chosen shakers
  let hotMealsArray = [];
  let sweetDishesArray = [];
  let everyMealsArray = [];
  let chosenShakersArray = [];
  let addOnProductsArray = [];

  // Function to update the displayed quantity and add/remove product from the respective array
  function updateQuantityAndCart(productName, productId, quantity, type) {
    // Function to update hot meals, sweet dishes, and every meals arrays
    /*function updateMealArray(cartArray = [], productName, productId, quantity) {
      let found = false;
      cartArray.forEach(function (item) {
        if (item.productName === productName) {
          item.quantity = quantity;
          found = true;
        }
      });
      if (!found && quantity > 0) {
        cartArray.push({ productName, productId, quantity });
      }
      return cartArray;
    }*/

    function updateMealArray(cartArray, productName, productId, quantity) {
      // 1. Normalize input: if it’s a JSON string, parse it; if not an array, start fresh
      let items = [];
      if (typeof cartArray === 'string') {
        try {
          items = JSON.parse(cartArray);
          if (!Array.isArray(items)) items = [];
        } catch {
          items = [];
        }
      } else if (Array.isArray(cartArray)) {
        items = cartArray;
      }
    
      // 2. Find existing item
      const idx = items.findIndex(item => item.productName === productName);
    
      if (idx > -1) {
        // 3a. If found, update or remove based on quantity
        if (quantity > 0) {
          items[idx].quantity = quantity;
        } else {
          items.splice(idx, 1);
        }
      } else if (quantity > 0) {
        // 3b. If not found and quantity > 0, add new
        items.push({ productName, productId, quantity });
      }
    
      return items;
    }


    const productTitleElement =
      type === "hot-meal"
        ? $(".hot-meals-jtpl .hot-meal.product-title").filter(function () {
            return $(this).text() === productName;
          })
        : type === "sweet-shaker"
        ? $(".sweet-shakers-jtpl .sweet-shaker.product-title").filter(
            function () {
              return $(this).text() === productName;
            }
          )
        : type === "every-meal"
        ? $(".everyday-meals-jtpl .every-meal.product-title").filter(
            function () {
              return $(this).text() === productName;
            }
          )
        : $(".add-ons-jtpl .add-on.product-title").filter(function () {
            return $(this).text() === productName;
          });

    const mainValueElement = productTitleElement
      .closest(".product_wrapper-inner-content")
      .find(".main-value");
    const inputMainValueElement = productTitleElement
      .closest(".product_wrapper-inner-content")
      .find(".quantity-jtpl");
    if (
      mainValueElement.text() == "" ||
      mainValueElement.text() == "NaN" ||
      mainValueElement.text() == "undefined" ||
      mainValueElement.text() == "null"
    ) {
      var currentQuantity = 0;
    } else {
      var currentQuantity = parseInt(mainValueElement.text());
    }

    var newQuantity = currentQuantity + quantity;
    if (
      newQuantity == "NaN" ||
      newQuantity == "undefined" ||
      newQuantity == "null"
    ) {
      newQuantity = 1;
    }

    // console.log(currentQuantity +"==========="+ newQuantity +"==============yessss");
    if (newQuantity <= 0) {
      if (type === "hot-meal") {
        hotMealsArray = hotMealsArray.filter(
          (item) => item.productName !== productName
        );
      } else if (type === "sweet-shaker") {
        sweetDishesArray = sweetDishesArray.filter(
          (item) => item.productName !== productName
        );
      } else if (type === "every-meal") {
        everyMealsArray = everyMealsArray.filter(
          (item) => item.productName !== productName
        );
      } else if (type === "add-on") {
        addOnProductsArray = addOnProductsArray.filter(
          (item) => item.productName !== productName
        );
      }
      mainValueElement.text(0);
      inputMainValueElement.val(0);
      $(".product-" + productId).removeClass("selected-jtpl");
    } else {
      mainValueElement.text(newQuantity);
      inputMainValueElement.val(newQuantity);
      if (type === "hot-meal") {
        hotMealsArray = updateMealArray(
          hotMealsArray,
          productName,
          productId,
          newQuantity
        );
      } else if (type === "sweet-shaker") {
        sweetDishesArray = updateMealArray(
          sweetDishesArray,
          productName,
          productId,
          newQuantity
        );
      } else if (type === "every-meal") {
        everyMealsArray = updateMealArray(
          everyMealsArray,
          productName,
          productId,
          newQuantity
        );
      } else if (type === "add-on") {
        addOnProductsArray = updateMealArray(
          addOnProductsArray,
          productName,
          productId,
          newQuantity
        );
      }
      $(".product-" + productId).addClass("selected-jtpl");
    }
  }

  // Function to handle selection of shakers
  $(document).on("click", ".shaker-select-button a", function (e) {
    e.preventDefault();
    var $this = $(this);
    chosenShakersArray = [];
    const productTitle = $(this)
      .closest(".product_wrapper-inner-content")
      .find(".shaker-product-title")
      .text();
    const productId = $(this).closest(".product_wrapper").attr("data-id");
    const productPrice = $(this).closest(".product_wrapper").attr("data-price");
    if ($this.closest(".product_wrapper").hasClass("selected-jtpl")) {
      if (
        $(this).closest(".product_wrapper").attr("data-id") != 48494683423035
      ) {
        $this.closest(".product_wrapper").removeClass("selected-jtpl");
        var yesTees = 0;
        if ($(".product-48494683423035").hasClass("selected-jtpl")) {
          var yesTees = 1;
        }
        $(".shaker-products-jtpl")
          .find(".product_wrapper")
          .removeClass("selected-jtpl")
          .removeClass("disabled-jtpl");
        $(".shaker-products-jtpl")
          .find(".product_wrapper")
          .find(".shaker-select-button a")
          .text("Seç");
        $(
          ".custom-step-button-cart.step-two-btn-jtpl.section-step-two-button"
        ).removeClass("active-btn-jtpl");
        if (yesTees == "1") {
          $(".product-48494683423035").addClass("selected-jtpl");
          $(".product-48494683423035")
            .find(".shaker-select-button a")
            .text("Çıkar");
        }
      } else {
        $this.closest(".product_wrapper").removeClass("selected-jtpl");
        $this
          .closest(".product_wrapper")
          .find(".shaker-select-button a")
          .text("Seç");
      }
    } else {
      if (
        $(this).closest(".product_wrapper").attr("data-id") != 48494683423035
      ) {
        $(".shaker-products-jtpl")
          .find(".product_wrapper")
          .removeClass("selected-jtpl")
          .addClass("disabled-jtpl");
      }
      $this
        .closest(".product_wrapper")
        .addClass("selected-jtpl")
        .removeClass("disabled-jtpl");
      $this.text("Çıkar");
      $(
        ".custom-step-button-cart.step-two-btn-jtpl.section-step-two-button"
      ).addClass("active-btn-jtpl");
    }
    $(".product-48494683423035").removeClass("disabled-jtpl");

    $(
      ".shaker-products-jtpl .product_wrapper.selected-jtpl .shaker-select-button a"
    ).each(function () {
      const productTitle = $(this)
        .closest(".product_wrapper-inner-content")
        .find(".shaker-product-title")
        .text();
      const productId = $(this).closest(".product_wrapper").attr("data-id");
      const productPrice = $(this)
        .closest(".product_wrapper")
        .attr("data-price");

      chosenShakersArray.push({
        productName: productTitle,
        productId: productId,
        quantity: 1,
        price: productPrice,
      });
    });
    var main_product = $(".main-product-jtpl").attr("data-main-product");

    console.log("Chosen Shakers Array:", chosenShakersArray);
    setCookie(
      "chosenShakersArray_" + main_product,
      JSON.stringify(chosenShakersArray),
      "40"
    );
    getData("shakers");
  });

  // Event listeners for quantity changes
  $(document).on("click", ".qty-plus,.qty-minus", function (e) {
    e.preventDefault();
    const productTitle = $(this)
      .closest(".product_wrapper-inner-content")
      .find(".product-title")
      .text();
    const productId = $(this).closest(".product_wrapper").attr("data-id");
    const type = $(this).closest(".product_wrapper").attr("data-type");
    console.log(
      $(".main-product-jtpl").attr("data-main-product") + "====" + type
    );
    //$(".main-product-jtpl").attr("data-main-product")=="9530664190267" && (
    if (type == "every-meal" || type == "sweet-shaker" || type == "hot-meal") {
      var quantity = $(this).hasClass("qty-plus") ? 10 : -10;
      if (quantity == "NaN" || quantity == "undefined" || quantity == "null") {
        quantity = 10;
      }
    } else {
      var quantity = $(this).hasClass("qty-plus") ? 1 : -1;
      if (quantity == "NaN" || quantity == "undefined" || quantity == "null") {
        quantity = 1;
      }
    }
    console.log("yess");
    console.log(quantity);
    updateQuantityAndCart(productTitle, productId, quantity, type);
    getData(type);
    var main_product = $(".main-product-jtpl").attr("data-main-product");
    setCookie(
      "everyMealsArray_" + main_product,
      JSON.stringify(everyMealsArray),
      "40"
    );
    setCookie(
      "hotMealsArray_" + main_product,
      JSON.stringify(hotMealsArray),
      "40"
    );
    setCookie(
      "sweetDishesArray_" + main_product,
      JSON.stringify(sweetDishesArray),
      "40"
    );
    setCookie(
      "addOnProductsArray_" + main_product,
      JSON.stringify(addOnProductsArray),
      "40"
    );
  });

  function getData(type = "") {
    if (type != "add-on" && type != "shakers") {
      var everyMealCount = 0;
      for (x = 0; x < everyMealsArray.length; x++) {
        everyMealCount = parseInt(everyMealCount) + everyMealsArray[x].quantity;
      }
      var hotMealsCount = 0;
      for (x = 0; x < hotMealsArray.length; x++) {
        hotMealsCount = parseInt(hotMealsCount) + hotMealsArray[x].quantity;
      }
      var sweetDishesCount = 0;
      for (x = 0; x < sweetDishesArray.length; x++) {
        sweetDishesCount =
          parseInt(sweetDishesCount) + sweetDishesArray[x].quantity;
      }
      var hotDishesCount = parseInt(everyMealCount) + parseInt(hotMealsCount);
      var totalCount =
        parseInt(everyMealCount) +
        parseInt(hotMealsCount) +
        parseInt(sweetDishesCount);
      var meal_cnt = parseInt($(".meal-days").attr("data-meals"));
      console.log(
        everyMealCount +
          "==" +
          hotMealsCount +
          "==" +
          sweetDishesCount +
          "==" +
          hotDishesCount
      );
      $(".hotdishes-cnt-jtpl").text(hotDishesCount + sweetDishesCount);

      // $(".sweet-cnt-jtpl").text(sweetDishesCount);
      // $(".progress-bar-inner.progress-bar-one").find(".step-progress-bar").removeClass("active-bar");
      //  $(".progress-bar-inner.progress-bar-one").find(".step-progress-bar").slice(0,sweetDishesCount).addClass("active-bar");

      $(".progress-bar-inner.progress-bar-two")
        .find(".step-progress-bar")
        .removeClass("active-bar");
      $(".progress-bar-inner.progress-bar-two")
        .find(".step-progress-bar")
        .slice(0, hotDishesCount + sweetDishesCount)
        .addClass("active-bar");
      console.log("totalCount >= meal_cnt");
      console.log(totalCount >= meal_cnt);
      if (totalCount >= meal_cnt) {
        $(
          ".custom-step-button-cart.step-one-btn-jtpl.section-step-one-button"
        ).addClass("active-btn-jtpl");
        $(
          ".main-tab-content.step-one .all-product-wrapper .weight-loss-products-quantity"
        ).addClass("disabled");
      } else {
        $(
          ".custom-step-button-cart.step-one-btn-jtpl.section-step-one-button"
        ).removeClass("active-btn-jtpl");
        $(
          ".main-tab-content.step-one .all-product-wrapper .weight-loss-products-quantity"
        ).removeClass("disabled");
      }
      $(".step-progressbar-section-jtpl .step-quantity").text(totalCount);
    } else {
      var tt_price = 0;
      if (addOnProductsArray.length > 0) {
        $(".footer-progress-bar-buttons").removeClass("active-jtpl");
        $(".footer-progress-bar-buttons.step-three").addClass("active-jtpl");
        for (var z = 0; z < addOnProductsArray.length; z++) {
          var prd_id = addOnProductsArray[z].productId;
          var qty = addOnProductsArray[z].quantity;
          //console.log(qty+"===="+$(".product-"+prd_id+" .addon-product-price").attr("data-price"));
          var final_price =
            qty *
            parseFloat(
              $(".product-" + prd_id + " .addon-product-price").attr(
                "data-price"
              )
            );
          tt_price = parseFloat(tt_price) + parseFloat(final_price);
        }
      }
      if (chosenShakersArray.length > 0) {
        // $(".shaker-products-jtpl .product_wrapper").removeClass("selected-jtpl").addClass("disabled-jtpl");
        for (var z = 0; z < chosenShakersArray.length; z++) {
          var prd_id = chosenShakersArray[z].productId;
          var qty = chosenShakersArray[z].quantity;
          $(".product-" + prd_id)
            .addClass("selected-jtpl")
            .removeClass("disabled-jtpl");
          if (
            parseFloat(
              $(".product-" + prd_id + " .addon-product-price").attr(
                "data-price"
              )
            ) > 0
          ) {
            var final_price =
              qty *
              parseFloat(
                $(".product-" + prd_id + " .addon-product-price").attr(
                  "data-price"
                )
              );
            tt_price = parseFloat(tt_price) + parseFloat(final_price);
          }
        }
      }

      var custom_main_price = $(".custom-step-button-cart a").attr(
        "data-price"
      );
      var custom_main_currency = $(".custom-step-button-cart a").attr(
        "data-currency"
      );
      tt_price = parseFloat(tt_price) + parseFloat(custom_main_price);
      tt_price = tt_price.toFixed(2);
      console.log("tt_price");
      console.log(tt_price);
      //var format = window.mwMotivatorObjects.shop.money_with_currency_format;
      var format = window.moneyFormat;
      var formatted_price = format.replace("{{amount_no_decimals}}", tt_price);
      $(".custom-step-button-cart a .price-main").text(formatted_price);
      console.log("formatted_price");
      console.log(format);
    }
  }

  function setMealsData() {
    var everyMealsArr = [];
    var hotMealsArr = [];
    var sweetDishesArr = [];
    var addOnProductsArr = [];
    var chosenShakersArr = [];
    var main_product = $(".main-product-jtpl").attr("data-main-product");
    if (getCookie("everyMealsArray_" + main_product)) {
      everyMealsArr = JSON.parse(getCookie("everyMealsArray_" + main_product));
    }
    if (getCookie("hotMealsArray_" + main_product)) {
      hotMealsArr = JSON.parse(getCookie("hotMealsArray_" + main_product));
    }
    if (getCookie("sweetDishesArray_" + main_product)) {
      sweetDishesArr = JSON.parse(
        getCookie("sweetDishesArray_" + main_product)
      );
    }
    if (getCookie("addOnProductsArray_" + main_product)) {
      addOnProductsArr = JSON.parse(
        getCookie("addOnProductsArray_" + main_product)
      );
    }
    if (getCookie("chosenShakersArray_" + main_product)) {
      chosenShakersArr = JSON.parse(
        getCookie("chosenShakersArray_" + main_product)
      );
    }

    hotMealsArray = hotMealsArr;
    sweetDishesArray = sweetDishesArr;
    everyMealsArray = everyMealsArr;
    chosenShakersArray = chosenShakersArr;
    addOnProductsArray = addOnProductsArr;

    console.log("get cookie array");
    console.log(everyMealsArr);
    console.log(hotMealsArr);
    console.log(sweetDishesArr);
    console.log(chosenShakersArr);
    console.log(addOnProductsArr);
    for (a = 0; a < everyMealsArr.length; a++) {
      console.log("enter-everyMealsArr");
      var qty = everyMealsArr[a].quantity;
      var id = everyMealsArr[a].productId;
      var prd_name = everyMealsArr[a].productName;
      console.log("qty + id + prd_name");
      console.log(qty + id + prd_name);
      $(".product-" + id)
        .find(".main-value")
        .text(qty);
      $(".product-" + id)
        .find(".quantity-jtpl")
        .val(qty);
      $(".product-" + id).addClass("selected-jtpl");
      var type = "every-meal";
      // updateQuantityAndCart(prd_name, id, qty, type);
      getData(type);
    }

    for (a = 0; a < hotMealsArr.length; a++) {
      var qty = hotMealsArr[a].quantity;
      var id = hotMealsArr[a].productId;
      var prd_name = hotMealsArr[a].productName;
      $(".product-" + id)
        .find(".main-value")
        .text(qty);
      $(".product-" + id)
        .find(".quantity-jtpl")
        .val(qty);
      $(".product-" + id).addClass("selected-jtpl");
      var type = "hot-meal";
      // updateQuantityAndCart(prd_name, id, qty, type);
      getData(type);
    }

    for (a = 0; a < sweetDishesArr.length; a++) {
      var qty = sweetDishesArr[a].quantity;
      var id = sweetDishesArr[a].productId;
      var prd_name = sweetDishesArr[a].productName;
      $(".product-" + id)
        .find(".main-value")
        .text(qty);
      $(".product-" + id)
        .find(".quantity-jtpl")
        .val(qty);
      $(".product-" + id).addClass("selected-jtpl");
      var type = "sweet-shaker";
      // updateQuantityAndCart(prd_name, id, qty, type);
      getData(type);
    }

    for (a = 0; a < addOnProductsArr.length; a++) {
      var qty = addOnProductsArr[a].quantity;
      var id = addOnProductsArr[a].productId;
      var prd_name = addOnProductsArr[a].productName;
      $(".product-" + id)
        .find(".main-value")
        .text(qty);
      $(".product-" + id)
        .find(".quantity-jtpl")
        .val(qty);
      $(".product-" + id).addClass("selected-jtpl");
      var type = "add-on";
      //updateQuantityAndCart(prd_name, id, qty, type);
      getData(type);
    }

    if (chosenShakersArr.length > 0) {
      $(".shaker-products-jtpl")
        .find(".product_wrapper")
        .removeClass("selected-jtpl")
        .addClass("disabled-jtpl");
    }
    for (a = 0; a < chosenShakersArr.length; a++) {
      var qty = chosenShakersArr[a].quantity;
      var id = chosenShakersArr[a].productId;
      var prd_name = chosenShakersArr[a].productName;
      $(".product-" + id).addClass("selected-jtpl");
      $(".product-" + id).removeClass("disabled-jtpl");
      $(".product-" + id)
        .find(".shaker-select-button a")
        .text("Çıkar");
      $(
        ".custom-step-button-cart.step-two-btn-jtpl.section-step-two-button"
      ).addClass("active-btn-jtpl");
      var type = "shakers";
      //updateQuantityAndCart(prd_name, id, qty, type);
      getData(type);
    }
    $(".product-48494683423035").removeClass("disabled-jtpl");
  }
  setMealsData();

  $("body").on(
    "click",
    ".custom-step-button-cart .section-custom-button-inner.button",
    function (e) {
      e.preventDefault();
      var step = $(this).attr("data-steps");
      // alert(step);
      $(".footer-progress-bar-buttons").removeClass("active-jtpl");
      $(".footer-progress-bar-buttons." + step).addClass("active-jtpl");
      $(".main-tabs#" + step).trigger("click");

      /****************************Final Step********************************************/
      if (step == "final") {
        $(".loader-spin-jtpl").show();
        $("body").addClass("loader-overlay-jtpl");
        $(".spinner-jtpl").addClass("nb-spinner-jtpl");
        if (
          everyMealsArray.length == 0 &&
          hotMealsArray.length == 0 &&
          sweetDishesArray.length == 0
        ) {
          alert("Please select your Meal from Step 1");
          $(".loader-spin-jtpl").hide();
          $("body").removeClass("loader-overlay-jtpl");
          $(".spinner-jtpl").removeClass("nb-spinner-jtpl");
          return false;
        }
        var everyMealCount = 0;
        for (x = 0; x < everyMealsArray.length; x++) {
          everyMealCount =
            parseInt(everyMealCount) + everyMealsArray[x].quantity;
        }
        var hotMealsCount = 0;
        for (x = 0; x < hotMealsArray.length; x++) {
          hotMealsCount = parseInt(hotMealsCount) + hotMealsArray[x].quantity;
        }
        var sweetDishesCount = 0;
        for (x = 0; x < sweetDishesArray.length; x++) {
          sweetDishesCount =
            parseInt(sweetDishesCount) + sweetDishesArray[x].quantity;
        }
        var hotDishesCount = parseInt(everyMealCount) + parseInt(hotMealsCount);
        var totalCount =
          parseInt(everyMealCount) +
          parseInt(hotMealsCount) +
          parseInt(sweetDishesCount);
        var meal_cnt = parseInt($(".meal-days").attr("data-meals"));
        if (totalCount < meal_cnt) {
          alert("Please select your " + meal_cnt + "Meals from Step 1");
          $(".loader-spin-jtpl").hide();
          $("body").removeClass("loader-overlay-jtpl");
          $(".spinner-jtpl").removeClass("nb-spinner-jtpl");
          return false;
        }
        var json_obj = [];
        /****************************Step -1 product data********************************************/
        var main_variant_id = $(".weight-loss-products").attr("data-product");
        //  alert(main_variant_id);
        var item = {
          id: main_variant_id,
          quantity: 1,
          properties: {},
        };
        var cnt = 0;
        for (x = 0; x < everyMealsArray.length; x++) {
          var pp_name = everyMealsArray[x].productName;
          var quantity = everyMealsArray[x].quantity;
          item.properties[pp_name] = quantity;
          //  item.properties["quantity"] = quantity;
          cnt++;
        }
        for (x = 0; x < hotMealsArray.length; x++) {
          var pp_name = hotMealsArray[x].productName;
          var quantity = hotMealsArray[x].quantity;
          item.properties[pp_name] = quantity;
          //  item.properties["quantity"] = quantity;
          cnt++;
        }
        for (x = 0; x < sweetDishesArray.length; x++) {
          var pp_name = sweetDishesArray[x].productName;
          var quantity = sweetDishesArray[x].quantity;
          item.properties[pp_name] = quantity;
          // item.properties["quantity"] = quantity;
          cnt++;
        }

        /****************************Step-2 shakers data********************************************/
        for (x = 0; x < chosenShakersArray.length; x++) {
          var pp_name = chosenShakersArray[x].productName;
          var quantity = chosenShakersArray[x].quantity;
          var variant_id = chosenShakersArray[x].productId;
          var price = chosenShakersArray[x].price;
          if (price > 0) {
            var item1 = {
              id: variant_id,
              quantity: quantity,
              properties: { main: main_variant_id },
            };
            json_obj.push(item1);
          } else {
            item.properties[pp_name] = quantity;
            // item.properties["quantity"] = quantity;
            cnt++;
          }
        }
        json_obj.push(item);

        /****************************Step-3 product data********************************************/
        for (x = 0; x < addOnProductsArray.length; x++) {
          var pp_name = addOnProductsArray[x].productName;
          var quantity = addOnProductsArray[x].quantity;
          var variant_id = addOnProductsArray[x].productId;
          var price = addOnProductsArray[x].price;
          var item2 = {
            id: variant_id,
            quantity: quantity,
            properties: { main: main_variant_id },
          };
          json_obj.push(item2);
        }
        console.log("################");
        console.log(json_obj);
        // add to cart all the values
        console.log(everyMealsArray);
        console.log(hotMealsArray);
        console.log(sweetDishesArray);
        console.log(addOnProductsArray);
        console.log(chosenShakersArray);
        /****************************Ajax Start*******************************************/

        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            items: json_obj,
          },
          dataType: "json",
          success: function (data) {
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", { bubbles: true })
            );
            setTimeout(function () {
              $(
                "cart-count.header__cart-count.header__cart-count--floating.bubble-count"
              ).trigger("click");
            }, 1500);
            var main_product =
              $(".main-product-jtpl").attr("data-main-product");

            console.log(main_product);

            /* Digimaps Added */

            // --- Cookie yardımcı fonksiyonları ---
            function setCookie(name, value, days) {
              let expires = "";
              if (days) {
                const date = new Date();
                date.setTime(date.getTime() + days*24*60*60*1000);
                expires = "; expires=" + date.toUTCString();
              }
              document.cookie = name + "=" + encodeURIComponent(value || "") + expires + "; path=/";
            }
            
            function getCookie(name) {
              const nameEQ = name + "=";
              const ca = document.cookie.split(";");
              for (let c of ca) {
                c = c.trim();
                if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
              }
              return null;
            }
            
            function eraseCookie(name) {
              document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
            }
            
            eraseCookie("everyMealsArray_" + main_product);
            eraseCookie("hotMealsArray_" + main_product);
            eraseCookie("sweetDishesArray_" + main_product);
            eraseCookie("addOnProductsArray_" + main_product);
            eraseCookie("chosenShakersArray_" + main_product);

            eraseCookie("everyMealsArray");
            eraseCookie("hotMealsArray");
            eraseCookie("sweetDishesArray");
            eraseCookie("addOnProductsArray");
            eraseCookie("chosenShakersArray");
            $(".loader-spin-jtpl").hide();
            $("body").removeClass("loader-overlay-jtpl");
            $(".spinner-jtpl").removeClass("nb-spinner-jtpl");
          },
        });

        /****************************Ajax End********************************************/
      } //step final
    }
  );
});
